// extracted by mini-css-extract-plugin
module.exports = {"container":"licenceError_container__2zKqf"};